import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StartPage').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.primary,
    width: '100%',
    height: '100%',
    opacity: '0',
    transform: 'translateY(20px)',
    transition: 'opacity 0.5s, transform 0.5s',
    zIndex: '99999',

    backgroundImage: 'url(/assets/backgrounds/PreloaderBG.webp)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    '&[data-visible="true"]': {
      opacity: '1',
      transform: 'translateY(0)',
    },
  },

  text: {
    display: 'flex',
    position: 'fixed',
    bottom: '3vh',
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: '450',
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.secondary,
    textAlign: 'center',
    width: '50%',
  },
}))
